export interface CepLookupResult {
  found: boolean;
  rua: string;
  bairro: string;
  cidade: string;
  estado: string;
}

const EMPTY: CepLookupResult = {
  found: false,
  rua: '',
  bairro: '',
  cidade: '',
  estado: '',
};

type CepProviderResponse = {
  erro?: boolean;
  logradouro?: string;
  bairro?: string;
  localidade?: string;
  uf?: string;
};

const mapResult = (data: CepProviderResponse): CepLookupResult => ({
  found: true,
  rua: data.logradouro || '',
  bairro: data.bairro || '',
  cidade: data.localidade || '',
  estado: data.uf || '',
});

/**
 * ViaCEP com fallback OpenCEP — mesma dupla de provedores que o StepThree usa.
 * Lá o código é inline; não foi extraído pra não mexer no funil de compra normal.
 */
export async function lookupCep(cep: string): Promise<CepLookupResult> {
  const digits = cep.replace(/\D/g, '');
  if (digits.length !== 8) return EMPTY;

  try {
    const response = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
    const data: CepProviderResponse = await response.json();
    if (!data?.erro && (data?.logradouro || data?.localidade)) return mapResult(data);
  } catch {
    /* cai no provedor alternativo */
  }

  try {
    const response = await fetch(`https://opencep.com/v1/${digits}.json`);
    const data: CepProviderResponse = await response.json();
    if (data && (data.logradouro || data.localidade)) return mapResult(data);
  } catch {
    /* preenchimento manual */
  }

  return EMPTY;
}
